import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowRight, Calendar, Clock } from 'lucide-react';
import { Card } from '../components/ui/card';

const blogPosts = [
  {
    id: 1,
    slug: 'best-affiliate-products-2025',
    title: 'Top 10 Highest Paying Affiliate Products in 2025',
    excerpt: 'Discover the affiliate products paying $100-$500 per sale with conversion rates above 5%. Real data from active marketers.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
    date: 'Jan 15, 2025',
    readTime: '8 min read',
    category: 'Product Reviews'
  },
  {
    id: 2,
    slug: 'passive-income-reddit-strategy',
    title: 'How I Made $3,847 in Passive Income Using Reddit (Step-by-Step)',
    excerpt: 'The exact Reddit strategy that generated consistent affiliate commissions without getting banned. Includes post templates and subreddits.',
    image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&q=80',
    date: 'Jan 12, 2025',
    readTime: '12 min read',
    category: 'Traffic Strategies'
  },
  {
    id: 3,
    slug: 'clickbank-affiliate-guide-beginners',
    title: 'ClickBank Affiliate Marketing for Beginners: Complete 2025 Guide',
    excerpt: 'Everything you need to know to start making money with ClickBank - from account setup to your first commission.',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
    date: 'Jan 10, 2025',
    readTime: '15 min read',
    category: 'Beginner Guides'
  },
  {
    id: 4,
    slug: 'free-traffic-sources-affiliate-marketing',
    title: '7 Free Traffic Sources That Actually Convert (No Paid Ads)',
    excerpt: 'Get targeted visitors without spending a dime. These free traffic methods are working right now in 2025.',
    image: 'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=800&q=80',
    date: 'Jan 8, 2025',
    readTime: '10 min read',
    category: 'Traffic Strategies'
  },
  {
    id: 5,
    slug: 'high-ticket-vs-low-ticket-affiliate',
    title: 'High-Ticket vs Low-Ticket Affiliate Products: What Converts Better?',
    excerpt: 'Real data comparing $500+ products vs $50 products. Which strategy makes more money with less traffic?',
    image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&q=80',
    date: 'Jan 5, 2025',
    readTime: '9 min read',
    category: 'Strategy'
  }
];

const Blog = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-emerald-600 to-teal-700 text-white py-20 px-4 mt-16">
        <div className="container mx-auto max-w-4xl text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Affiliate Marketing Insights & Strategies
          </h1>
          <p className="text-xl text-emerald-100">
            Real tactics, honest reviews, and proven methods to build passive income in 2025
          </p>
        </div>
      </div>

      {/* Blog Posts Grid */}
      <div className="container mx-auto max-w-6xl px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <Link key={post.id} to={`/blog/${post.slug}`}>
              <Card className="overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group h-full">
                <div className="relative overflow-hidden">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-emerald-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                      {post.category}
                    </span>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
                    <div className="flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      {post.date}
                    </div>
                    <div className="flex items-center gap-1">
                      <Clock className="w-4 h-4" />
                      {post.readTime}
                    </div>
                  </div>
                  
                  <h2 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-emerald-600 transition-colors">
                    {post.title}
                  </h2>
                  
                  <p className="text-gray-600 mb-4 line-clamp-3">
                    {post.excerpt}
                  </p>
                  
                  <div className="flex items-center text-emerald-600 font-semibold group-hover:gap-2 transition-all">
                    Read More <ArrowRight className="w-4 h-4 ml-1" />
                  </div>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};export default Blog;
